/* eslint-disable no-unused-vars */
import {
  CellRendererSelector,
  GenericContent,
  DotsMenu,
  DailyBudget,
  CampaignName,
  TargetedLocation,
  Bid,
} from '../../components/manageCampaigns/grid/components/index';

export const immutableCols = ['action', 'status', 'campaign', 'bid', 'budget'];

export const mandatoryColumns = [
  {
    headerName: '',
    colId: 'action',
    field: 'action',
    cellRenderer: DotsMenu,
    editable: false,
    sortable: false,
    maxWidth: 64,
    minWidth: 64,
    width: 64,
    pinned: 'left',
    suppressMovable: true,
    resizable: false,
    lockPosition: true,
    cellRendererSelector: CellRendererSelector,
  },
  {
    headerName: 'Campaign',
    field: 'campaign',
    colId: 'campaign',
    filter: 'agTextColumnFilter',

    editable: false,
    minWidth: 355,
    maxWidth: 355,
    cellRenderer: CampaignName,
    pinned: 'left',
    suppressMovable: true,
    resizable: false,
    lockPosition: true,
    cellRendererSelector: CellRendererSelector,
  },
  {
    headerName: 'Bid',
    field: 'bid',
    colId: 'bid',
    filter: false,
    width: 129,
    minWidth: 129,
    maxWidth: 129,
    cellRenderer: Bid,
    cellRendererSelector: CellRendererSelector,
    suppressMovable: true,
    resizable: false,
    lockPosition: true,
  },
  {
    headerName: 'Daily Budget',
    field: 'budgetPercentage',
    colId: 'budget',
    width: 185,
    minWidth: 185,
    maxWidth: 185,
    cellRenderer: DailyBudget,
    cellRendererSelector: CellRendererSelector,
    suppressMovable: true,
    resizable: false,
    lockPosition: true,
    filter: false,
  },
];
export const allAdditionalFields = [
  {
    headerName: 'Targeted Location',
    field: 'countries',
    colId: 'countries',
    filter: false,
    cellRenderer: TargetedLocation,
    cellRendererSelector: CellRendererSelector,
    suppressMovable: true,
    resizable: false,
    width: 112,
    minWidth: 112,
    maxWidth: 112,
  },
  {
    headerName: 'Viewable Impressions',
    field: 'impressions',
    colId: 'impressions',
    filter: false,
    cellRendererSelector: CellRendererSelector,
    cellRenderer: GenericContent,
    cellRendererParams: {
      valueType: 'number',
    },
    suppressMovable: true,
    resizable: false,
    width: 112,
    minWidth: 112,
    maxWidth: 112,
  },
  {
    headerName: 'Clicks',
    field: 'clicks',
    colId: 'clicks',
    filter: false,
    cellRenderer: GenericContent,
    cellRendererSelector: CellRendererSelector,
    cellRendererParams: {
      valueType: 'number',
    },
    suppressMovable: true,
    resizable: false,
    width: 100,
    minWidth: 100,
    maxWidth: 100,
  },
  {
    headerName: 'CTR',
    field: 'ctr',
    colId: 'ctr',
    filter: false,
    cellRenderer: GenericContent,
    cellRendererSelector: CellRendererSelector,
    cellRendererParams: {
      valueType: 'percentage',
    },
    suppressMovable: true,
    resizable: false,
    width: 70,
    minWidth: 70,
    maxWidth: 70,
  },
  {
    headerName: 'Installs',
    field: 'installs',
    colId: 'installs',
    filter: false,
    cellRenderer: GenericContent,
    cellRendererSelector: CellRendererSelector,
    cellRendererParams: {
      valueType: 'number',
    },
    suppressMovable: true,
    resizable: false,
    width: 112,
    minWidth: 112,
    maxWidth: 112,
  },
  {
    headerName: 'Conv. Rate',
    field: 'cr',
    colId: 'cr',
    filter: false,
    cellRenderer: GenericContent,
    cellRendererSelector: CellRendererSelector,
    cellRendererParams: {
      valueType: 'percentage',
    },
    suppressMovable: true,
    resizable: false,
    width: 100,
    minWidth: 100,
    maxWidth: 100,
  },
  {
    headerName: 'Cost',
    field: 'cost',
    colId: 'cost',
    filter: false,
    cellRenderer: GenericContent,
    cellRendererSelector: CellRendererSelector,
    cellRendererParams: {
      valueType: 'dollars',
    },
    suppressMovable: true,
    resizable: false,
    width: 105,
    minWidth: 105,
    maxWidth: 105,
  },
  {
    headerName: 'eCPM',
    field: 'ecpm',
    colId: 'ecpm',
    filter: false,
    cellRenderer: GenericContent,
    cellRendererSelector: CellRendererSelector,
    cellRendererParams: {
      valueType: 'number',
    },
    suppressMovable: true,
    resizable: false,
    width: 105,
    minWidth: 105,
    maxWidth: 105,
  },
  {
    headerName: 'Video Views',
    field: 'video_views',
    colId: 'video_views',
    filter: false,
    cellRenderer: GenericContent,
    cellRendererSelector: CellRendererSelector,
    cellRendererParams: {
      valueType: 'number',
    },
    suppressMovable: true,
    resizable: false,
    width: 105,
    minWidth: 105,
    maxWidth: 105,
  },
  {
    headerName: 'Video Ended',
    field: 'video_completed',
    colId: 'video_completed',
    filter: false,
    cellRenderer: GenericContent,
    cellRendererSelector: CellRendererSelector,
    cellRendererParams: {
      valueType: 'number',
    },
    suppressMovable: true,
    resizable: false,
    width: 105,
    minWidth: 105,
    maxWidth: 105,
  },
  {
    headerName: 'AVG CPI',
    field: 'avg_cpi',
    colId: 'avg_cpi',
    filter: false,
    cellRenderer: GenericContent,
    cellRendererSelector: CellRendererSelector,
    cellRendererParams: {
      valueType: 'dollars',
    },
    suppressMovable: true,
    resizable: false,
    width: 80,
    minWidth: 80,
    maxWidth: 80,
  },
];
export const allFields = [...mandatoryColumns, ...allAdditionalFields];

export const flexTableHeader = {
  flex: 1,
  headerName: '',
  editable: false,
  sortable: false,
  suppressMovable: true,
  resizable: false,
};
